import React from 'react';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronLeftDoubleIcon,
  ChevronRightDoubleIcon,
} from '../icons';

import css from './css';

interface Props {
  add: () => void;
  remove: () => void;
  addAll?: () => void;
  removeAll?: () => void;
  invert?: boolean;
}

const selectControls = (props: Props) => (
  <>
    <button
      type="button"
      style={{ marginTop: 28 }}
      onClick={!props.invert ? props.add : props.remove}
      // @ts-ignore
      className={customStyles.control}
      data-testid="select-two-column-add"
    >
      <ChevronRightIcon key="0" color="#ccc" width="18" />
    </button>
    {/* @ts-ignore */}
    <button
      type="button"
      onClick={!props.invert ? props.remove : props.add}
      className={customStyles.control}
      data-testid="select-two-column-remove"
    >
      <ChevronLeftIcon key="1" color="#ccc" width="18" />
    </button>
    {/* @ts-ignore */}
    <button
      type="button"
      id="add-all"
      onClick={!props.invert ? props.addAll : props.removeAll}
      className={customStyles.control}
      data-testid="select-two-column-add-all"
    >
      <ChevronRightDoubleIcon key="2" color="#ccc" width="20" />
    </button>
    {/* @ts-ignore */}
    <button
      type="button"
      onClick={!props.invert ? props.removeAll : props.addAll}
      className={customStyles.control}
      data-testid="select-two-column-remove-all"
    >
      <ChevronLeftDoubleIcon key="3" color="#ccc" width="20" />
    </button>
  </>
);

const customStyles = css<any>({
  control: {
    width: 40,
    height: 40,
    border: '1px solid #ddd',
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 4,
    margin: 5,
    cursor: 'pointer',
  },
});

export default selectControls;
